import { r as a, c as l, P as c, h as r, H as h, g as d } from "./main-bb89b2f2.js";
import "vue";
const p = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}", f = p, g = class {
  constructor(i) {
    a(this, i), this.change = l(this, "lhChange", 7), this.listOfItems = [], this.queryAccordionItems = (o) => {
      var t, e;
      o == null || o.stopImmediatePropagation(), this.listOfItems = Array.from((e = (t = this.hostElement) === null || t === void 0 ? void 0 : t.querySelectorAll("patternlib-accordion-item")) !== null && e !== void 0 ? e : []);
      let n = 0;
      for (const s of this.listOfItems)
        s.type = this.type, s.keepOpenOnDesktop = this.keepOpenOnDesktop, s.isFirst = this.listOfItems.length === 1, s.isLast = n == this.listOfItems.length - 1, s.applicationContext = this.applicationContext, n++;
    }, this.type = "default", this.allowToExpandAll = !1, this.keepOpenOnDesktop = !1, this.applicationContext = c.getContext();
  }
  watchApplicationContextChanges(i) {
    console.log("CHANGE", i), this.queryAccordionItems();
  }
  /**
   * if allowToExpandAll is set to FALSE, all items except the last that were clicked inside this accordion instance are closed
   * if allowToExpandAll is set to TRUE, on open of item adjacent items that are opened too are given the adjacent state for different styling
   * @param evt
   */
  async processSurroundingItems(i) {
    if (this.allowToExpandAll) {
      let t = 0;
      for (const e of this.listOfItems)
        t > 0 && await e.setAdjacent(e.isOpen && this.listOfItems[t - 1].isOpen), t++;
    } else if (i.detail === "open") {
      const t = i.target;
      for (const e of this.listOfItems)
        e !== t && await e.closePanel();
    }
    const o = this.listOfItems.reduce((t, e, n) => (e.isOpen && t.push(n), t), []);
    this.change.emit({ value: o });
  }
  componentWillLoad() {
    this.queryAccordionItems();
  }
  render() {
    return r(h, { key: "9d2408a3046a0708938398902df99638f39e996c" }, r("slot", { key: "86c3ac1021139eec4d9ba712ce1d083753ea7420", onSlotchange: this.queryAccordionItems }));
  }
  get hostElement() {
    return d(this);
  }
  static get watchers() {
    return {
      applicationContext: ["watchApplicationContextChanges"]
    };
  }
};
g.style = f;
export {
  g as patternlib_accordion
};
